export default "__VITE_ASSET__wEzaDLSj__"